import Pace from 'pace-js';

Pace.start();



// WEBPACK FOOTER //
// ./frontend/src/js/loader.js